import React from "react";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { ButtonProps } from "../../Buttons/interface/ButtonInterface";

const DeleteButton: React.FC<Partial<ButtonProps>> = ({
  action,
  data,
  permission,
  ...rest
}) => {
  if (!permission) {
    return null;
  }

  delete rest?.permissionKey;

  return (
    <Button
      type="text"
      title={"Delete"}
      className="deleteIcon"
      onClick={() => action && action(data)}
      {...rest}
    >
      <DeleteOutlined/>
    </Button>
  );
};

export default DeleteButton;
